<template>
  <div>
    <div
      v-for="(_, row) in Array(Math.ceil(nonEmptySections.length / columns)).fill(0)"
      :key="row"
      class="d-flex pa-2"
    >
      <div
        v-for="({ showSection, name, links }) in getSectionsByRow(row)"
        :key="name"
        class="list-section"
        :class="{ compact }"
        :style="{ 'min-width': props.minWidth ? `${props.minWidth}px` : undefined }"
      >
        <slot
          v-if="showSection"
          name="header"
          v-bind="{ name }"
        />

        <div
          v-for="link in links.filter((l) => l.show)"
          :key="link.title"
          class="ml-4 navigation-list-item"
          :class="{ 'no-events': link.isSoon || link.isUpgrade }"
        >
          <NoEditorWrapper
            :no-editor="Boolean(link.isUpgrade)"
          >
            <component
              :is="link.to ? 'router-link' : 'a'"
              :to="link.to ? {
                name: link.to,
                query: link.query || {
                  ...getQueryParam(link.to),
                  key: link.inviteKey ? link.inviteKey : undefined,
                },
              } : undefined"
              class="item-content"
              v-bind="{
                ...(link.href
                  ? { href: link.href, rel: 'noopener noreferrer' }
                  : {}
                ),
                ...link.attributes,
              }"
              @click="link.onClick ? link.onClick() : undefined"
            >
              <slot
                name="item"
                v-bind="link"
              />
            </component>
          </NoEditorWrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import NoEditorWrapper from '@/components/editor/NoEditorWrapper.vue';
import { computed } from 'vue';

const props = defineProps({
  columns: { type: Number, default: 3 },
  linkSections: { type: Array, default: () => [] },
  getQueryParam: { type: Function, default: () => ({}) },
  minWidth: { type: Number, default: 220 },
  compact: { type: Boolean, default: false },
});

defineEmits(['tracking-event']);

const nonEmptySections = computed(() => props.linkSections
  .filter((section) => section.links.find((link) => link.show)));

const getSectionsByRow = (row) => nonEmptySections.value
  .slice(row * props.columns, row * props.columns + props.columns);
</script>

<style scoped lang="less">
.no-events {
  pointer-events: none;
}

.list-section {
  cursor: initial;

  :deep(.list-item) {
    min-height: 36px;
    height: 36px;
    font-size: 14px;
  }

  &.compact:deep(.list-item) {
    min-height: 30px;
    height: 30px;
    font-size: 12px;
  }
}

.navigation-list-item {
  :deep(.v-list-item__content) {
    color: fade(@grey-700, 95%);
    font-weight: 500;
  }

  :deep(.list-item-container:hover) {
    .list-item.v-list-item.v-list-item--link {
      border-left: 4px solid @brand-primary;
      border-radius: 0 4px 4px 0 !important;
      color: @text-brand !important;
      margin-left: -4px;
    }
  }
}

.compact .navigation-list-item {
  :deep(.list-item-container:hover) {
    .list-item.v-list-item.v-list-item--link {
      border-left: 2px solid @brand-primary;
      margin-left: -2px;
    }
  }
}
</style>
